// extracted by mini-css-extract-plugin
export default {"signInSignUp":"b_Irm","signInSignUp__text":"Qux1F","signInSignUp__button":"D6xy2","signInSignUp__button___signUp":"LJB2k"};